module.exports = __webpack_public_path__ + "static/media/tn.fea87146.svg";